import {QueryClient} from '@tanstack/react-query';

export const staticQueryDefaults = {
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: 'always',
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
} as const;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            gcTime: 30 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1
        }
    }
});
